module.exports = __webpack_public_path__ + "static/media/9306185377_97110799a4_z.6911fe58.jpg";